<div [attr.data-cursor]="cursor() !== 'pointer' || disabled() ? 'hover-disabled' : 'hover-enabled'"
     [class.gap-8]="(!contentOnHover() || hovering()) && size() === 'big'"
     [class.gap-2]="(!contentOnHover() || hovering()) && size() === 'small'"
     class="{{colorClass()}} chips relative" [class.no-transition]="!transitionsReady()" [style.height]="contentHeight() ? 'inherit' : '32px'"
     (click)="onAction($event)"
     (mouseenter)="onHoverEnter()"
     (mouseleave)="onHoverLeave()">

  @if (loading()) {
    <mat-spinner [diameter]="20" class="spinner-{{state()}}"></mat-spinner>
  } @else {
    @if (iconLeft()) {
      @if (isSvgIcon(iconLeft())) {
        <mat-icon class="small-icon shrink-0" [svgIcon]="iconLeft()" [style.color]="iconColor()"></mat-icon>
      } @else {
        <mat-icon class="small-icon shrink-0" [style.color]="iconColor()">{{ iconLeft() }}</mat-icon>
      }
    }
  }
  @if (contentOnHover()) {
    <ng-container *ngTemplateOutlet="contentTemplateHover"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  }

  @if (roundedValue()) {
    <span class="pellet pellet-{{state()}}">{{ roundedValue() }}</span>
  }
  @if (iconRight()) {
    @if (isSvgIcon(iconRight())) {
      <mat-icon class="small-icon shrink-0" [svgIcon]="iconRight()" (click)="iconRightAction.emit()"></mat-icon>
    } @else if (iconRight()) {
      <mat-icon class="small-icon shrink-0" (click)="iconRightAction.emit()">{{ iconRight() }}</mat-icon>
    }
  }
  @if (bubble() || (showBubbleZero() && bubble() === 0)) {
    <div class="top-alert tiny flex-col {{_bubbleClasses()}}" [style.left]="left()"><span
      class="self-center">{{ bubbleFormatted() }}</span></div>
  }
</div>

<ng-template #contentTemplateHover>
  <span
    class="content-anim"
    [class.open]="isOpen()"
    (transitionend)="onWidthTransitionEnd($event)"
  >
    <span
      class="inner"
      [class.show]="showText()"
      [class.unclamped]="unclampText()"
      (transitionend)="onOpacityTransitionEnd($event)"
    >
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </span>
  </span>
</ng-template>

<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>


